import { type FC, type ReactNode } from 'react'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import TooltipActions, { type ActionProps } from './_internal/TooltipActions'
import * as styles from './styles'

type TooltipContentProps = {
  title?: string
  actions?: ActionProps[]
  children: ReactNode
}

const TooltipContent: FC<TooltipContentProps> = ({ title, children, actions }) => {
  const theme = useTheme()

  return (
    <div css={styles.content(theme)}>
      {title && (
        <Typography variant="h3" css={styles.title(theme)}>
          {title}
        </Typography>
      )}
      {children}
      {!!actions && <TooltipActions actions={actions} />}
    </div>
  )
}

export default TooltipContent
